import request from '@/utils/request';

export function queryShopAddressList(query) {
  return request({
    url: '/api/system/shopAddress/queryShopAddressList',
    method: 'post',
    data: query
  });
}
export function saveShopAddress(form) {
  return request({
    url: '/api/system/shopAddress/saveShopAddress',
    method: 'post',
    data: form
  });
}
export function getShopAddress(form) {
  return request({
    url: '/api/system/shopAddress/getShopAddress',
    method: 'post',
    data: form
  });
}
export function updateShopAddress(form) {
  return request({
    url: '/api/system/shopAddress/updateShopAddress',
    method: 'post',
    data: form
  });
}
export function defaultAddress(form) {
  return request({
    url: '/api/system/shopAddress/defaultAddress',
    method: 'post',
    data: form
  });
}

export function deleteShopAddress(form) {
  return request({
    url: '/api/system/shopAddress/deleteShopAddress',
    method: 'post',
    data: form
  });
}



// WEBPACK FOOTER //
// ./src/api/address/index.js